import * as acc from "../libraries/accessibility";
var countClick = 0;
document.addEventListener('click', e => {
  if (e.target.matches('#btn-invert-color')) {
    countClick += 1;
    if (countClick <= 1) {
      acc.changeTheme('highContrast path-frontpage page-node-type-homepage bg- d-flex flex-column h-100');
    } else if(countClick <= 2) {
      acc.changeTheme("highContrastHalfColor path-frontpage page-node-type-homepage bg- d-flex flex-column h-100");
    } else if (countClick <= 3){
      acc.changeTheme("highContrastHalfColorBright path-frontpage page-node-type-homepage bg- d-flex flex-column h-100");
    } else if (countClick <= 4) {
      acc.changeTheme("grayScale path-frontpage page-node-type-homepage bg- d-flex flex-column h-100");
    } else {
      acc.changeTheme("path-frontpage page-node-type-homepage bg- d-flex flex-column h-100");
      countClick = 0;
    }
  }
})
